import React from "react";
export const EmailColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {isEdit,setEmailValue,emailValue}
) =>{

  if(isEdit===row.id)
  {
    return (
    <>
        <input
            type="text"
            className="form-control"
            name="email"
            placeholder="Search"
            value={emailValue}
            onChange={(e) => {
            setEmailValue(e.target.value);
            }}
        />
    </>)
  }
  else
  {
    return  (
      <>
      {row.email}
      </>
    )
  }
}
